import useAppStore from "@/store/use-app-store";
import { Avatar, Box, Typography } from "@mui/material";
import React from "react";
// import { useAuth } from "react-oidc-context";

export function AvatarField(properties) {
  // const auth = useAuth();
  const { clientName, companyName, companyStyle } = useAppStore();
  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          padding: "8px",
        }}
      >
        <Avatar
          alt={clientName}
          // src={""}
          sx={{
            color: "inherit",
            height: "100px",
            width: "100px",
          }}
        >
          {clientName ? clientName.charAt(0) : ""}
        </Avatar>
      </Box>
      <Box sx={{ alignSelf: "center", textAlign: "center", width: "100%" }}>
        <Typography variant="h5">{clientName}</Typography>
        <Box
          sx={{
            alignItems: "baseline",
            display: "flex",
            flexDirection: "row",
            gap: "4px",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {(companyStyle?.logoMain?.url || companyStyle?.logoSecond?.url) && (
            <img
              alt="logo"
              src={companyStyle?.logoMain?.url || companyStyle?.logoSecond?.url}
              style={{
                height: "13px",
                width: "auto",
              }}
            />
          )}
          <Typography variant="body1">{companyName}</Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
}
